import { render, staticRenderFns } from "./MnemonicsEditor.vue?vue&type=template&id=050b3828&scoped=true&"
import script from "./MnemonicsEditor.vue?vue&type=script&lang=js&"
export * from "./MnemonicsEditor.vue?vue&type=script&lang=js&"
import style0 from "./MnemonicsEditor.vue?vue&type=style&index=0&id=050b3828&prod&scoped=true&lang=css&"
import style1 from "./MnemonicsEditor.vue?vue&type=style&index=1&id=050b3828&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050b3828",
  null
  
)

export default component.exports